const BIDI_CONTROL_RE = /[\u202A-\u202E\u2066-\u2069]/g;
const ASCII_LETTER_RE = /^[A-Za-z]$/;
const ASCII_NUMBER_RE = /^[0-9]$/;

function toDisplayText(value) {
	return String(value == null ? '' : value)
		.replace(BIDI_CONTROL_RE, '')
		.trim();
}

function toNormalizedText(value) {
	const text = toDisplayText(value);
	if (!text) {
		return '';
	}
	return typeof text.normalize === 'function' ? text.normalize('NFKC') : text;
}

function isCjkCharacter(char) {
	const codePoint = char.codePointAt(0);
	return (codePoint >= 0x3400 && codePoint <= 0x4DBF)
		|| (codePoint >= 0x4E00 && codePoint <= 0x9FFF)
		|| (codePoint >= 0xF900 && codePoint <= 0xFAFF)
		|| (codePoint >= 0x3040 && codePoint <= 0x30FF)
		|| (codePoint >= 0xAC00 && codePoint <= 0xD7AF);
}

function isLetterLike(char) {
	return char.toLocaleUpperCase() !== char.toLocaleLowerCase();
}

function toSingleCharacter(value) {
	return Array.from(value || '')[0] || '';
}

export function normalizeAvatarName(name) {
	return toNormalizedText(name);
}

export function getAvatarPlaceholderText(name, fallback = '') {
	const text = normalizeAvatarName(name);
	if (!text) {
		return fallback;
	}
	const chars = Array.from(text);
	for (const char of chars) {
		if (ASCII_LETTER_RE.test(char)) {
			return char.toUpperCase();
		}
		if (ASCII_NUMBER_RE.test(char) || isCjkCharacter(char)) {
			return char;
		}
		if (isLetterLike(char)) {
			return toSingleCharacter(char.toLocaleUpperCase());
		}
	}
	return fallback;
}

export function getAvatarColorIndex(name, paletteLength = 6) {
	const safePaletteLength = Number.isFinite(Number(paletteLength)) && Number(paletteLength) > 0
		? Math.floor(Number(paletteLength))
		: 1;
	const text = normalizeAvatarName(name);
	if (!text) {
		return 0;
	}
	let hash = 0;
	Array.from(text).forEach((char) => {
		hash = (hash * 31 + char.codePointAt(0)) % safePaletteLength;
	});
	return hash;
}
